import {useState} from 'react'
import {KTCard} from '../../../../_metronic/helpers'
import Breadcrumbs from '../../../sharedComponent/Breadcrumbs/Breadcrumbs'
import {useLocation, useNavigate, useParams} from 'react-router-dom'
import Questions from '../Questions'
import {useLazyQuery, useMutation} from '@apollo/client'
import {
  CHECK_OUTBOUND_CUSTOMER_CALL_STATUS,
  LIVEAGENT_LEAVE_CALL,
} from '../../../../utils/GraphQLAPI'
import {alert, areYouSurePrompt, renderPhoneNumber} from '../../../../utils/helper'
import {GLOBAL_CONSTANTS} from '../../../../utils/GlobalConstants'
import {Col, Row} from 'react-bootstrap'

type LocationState = {
  tpvId: string
  pincode: string
  failScript: string | null
  customerName: string | null
  dialInNumber: string
  clientName: string
}

const OutboundLiveAgentCall = () => {
  const [callAnswered, setCallAnswered] = useState(false)
  const [startTpv, setStartTpv] = useState(false)
  const [index, setIndex] = useState(1)
  const [verified, setIsVerified] = useState(false)
  const [showGoBack, setShowGoBack] = useState(false)
  const [isFlagged, setIsFlagged] = useState(false)
  const [dispositionMsg, setDispositionMsg] = useState('')
  const [leaveMessage, setLeaveMessage] = useState(false)
  const [CallNotAnswered, setCallNotAnswered] = useState(false)

  const getUrlParams = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const tpvId = (location.state as LocationState).tpvId
  const pincode = (location.state as LocationState).pincode
  const failScript = (location.state as LocationState).failScript
  const customerName = (location.state as LocationState).customerName
  const DialInNumber = (location.state as LocationState).dialInNumber
  const clientName = (location.state as LocationState).clientName

  const [sendCustomerCallStatus] = useLazyQuery(CHECK_OUTBOUND_CUSTOMER_CALL_STATUS, {
    onCompleted: () => setIsVerified(true),
    onError: (err) => alert(err.message, 'error'),
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
  })

  const [leaveCall] = useMutation(LIVEAGENT_LEAVE_CALL)
  const onComplete = () => {
    setShowGoBack(true)
    setStartTpv(false)
      leaveCall({
        variables: {
          tpvId: tpvId,
          isCustomerFlagged: isFlagged?isFlagged:false,
          disposition: Boolean(dispositionMsg)?dispositionMsg:null,
        },
      })
    
  }
  return (
    <>
      <Breadcrumbs
        title='Outbound customer name'
        subTitle='Home - Outbound Live Agent Call - customer name'
      />
      <KTCard>
        <div className='card-body'>
          <table className='table table-rounded table-striped border gy-7 gs-7'>
            <thead>
              <tr className='fw-bold fs-6 text-gray-800 border-bottom border-gray-200'>
                <th>Customer Name</th>
                <th>Dial In Number</th>
                <th>Pincode</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{customerName}</td>
                <td>{renderPhoneNumber(DialInNumber)}</td>
                <td>{pincode}</td>
              </tr>
            </tbody>
          </table>
          {startTpv && (
            <div className='my-4 text-center'>
              <button
                className='btn btn-danger me-2'
                onClick={() => {
                  areYouSurePrompt(
                    'Are you sure?',
                    () => {
                      leaveCall({
                        variables: {
                          tpvId: tpvId,
                          tpvStatus: 'Incomplete',
                          disposition: Boolean(dispositionMsg) ? dispositionMsg : null,
                        },
                      })
                      setStartTpv(false)
                      setShowGoBack(true)
                    },
                    () => {},
                    'Yes, leave the call',
                    'No, stay in the call',
                    'This will make the TPV status as Incomplete'
                  )
                }}
              >
                {' '}
                Leave Call
              </button>
              <button
                className='btn btn-danger me-2'
                onClick={() => {
                  areYouSurePrompt(
                    'Are you sure?',
                    () => {
                      leaveCall({
                        variables: {
                          tpvId: tpvId,
                          tpvStatus: 'Failed',
                          disposition: Boolean(dispositionMsg) ? dispositionMsg : null,
                        },
                      })
                      setStartTpv(false)
                      setShowGoBack(true)
                      setLeaveMessage(true)
                    },
                    () => {},
                    'Yes, fail the TPV',
                    'No, stay in the call',
                    'This will fail the TPV'
                  )
                }}
              >
                Leave call and fail TPV
              </button>
            </div>
          )}

          { !CallNotAnswered && !leaveMessage && !startTpv && !showGoBack && (
            <h4 className='fs-5 my-5 text-center'>
              This is TPV Solutions calling on behalf of {clientName}. May I speak to {customerName}
              ?
            </h4>
          )}
          {startTpv && (
            <Row>
              <Col lg={'6'}>
                <KTCard className={`${'bg-f5f8fa'} h-100 align-items-center py-3`}>
                  <h4 className='text-center'>Rules</h4>
                  <ul>
                    <li>
                      <h6>Clear Yes or No</h6>
                    </li>
                    <li>
                      <h6>Type in other for all other answers</h6>
                    </li>
                  </ul>
                </KTCard>
              </Col>
              <Col lg={'6'}>
               
                  
                    <div className='form-check form-check-custom form-check-solid d-inline-block me-3'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        checked={isFlagged}
                        onChange={() => setIsFlagged((prev: boolean) => !prev)}
                        id='flexCheckDefault'
                      />
                      <label className='form-check-label' htmlFor='flexCheckDefault'>
                        Flag Account for Additional QC Review
                      </label>
                    </div>
                  
                  <div className='mt-4'>
                    <label className='fs-5 fs-5 fw-bold mb-2'>Disposition</label>
                    <textarea
                      name='businessDescription'
                      className='form-control form-control-lg form-control-solid resize-none min-w-450px min-h-100px'
                      value={dispositionMsg}
                      placeholder='Enter  disposition'
                      maxLength={2000}
                      onChange={(e) => {
                        setDispositionMsg(e.target.value)
                      }}
                      rows={1}
                    ></textarea>
                  </div>
             
              </Col>
            </Row>
          )}

          {!CallNotAnswered && !leaveMessage && !startTpv && !callAnswered && (
            <div className='text-center'>
              <button
                className='btn btn-danger me-2'
                onClick={() => {
                  setLeaveMessage(false)
                  setCallNotAnswered(true)
                  sendCustomerCallStatus({
                    variables: {
                      answered: false,
                      tpvId: tpvId,
                    },
                  })
                }}
              >
                {' '}
                Call Not Answered
              </button>
              <button
                className='btn btn-success'
                onClick={() => {
                  setCallAnswered(true)
                  sendCustomerCallStatus({
                    variables: {
                      answered: true,
                      tpvId: tpvId,
                    },
                  })
                  setStartTpv(true)
                }}
              >
                Start TPV
              </button>
            </div>
          )}
          {/* {callAnswered && (
              <div>
                {!leaveMessage && startTpv && (
                  <>
                  
                  </>
                )}
              </div>
            )} */}

          {verified && startTpv && (
            <Questions
              index={index}
              setIndex={setIndex}
              pincode={pincode}
              setIsVerified={setIsVerified}
              customerName={customerName}
              onComplete={onComplete}
              cardClassName={''}
              isFlagged={isFlagged}
            />
          )}
          {leaveMessage && (
            <div className='text-center my-4'>
              <h4 className='fs-5 '>Voice Mail Script</h4>
              <p>{failScript}</p>
            </div>
          )}
          {CallNotAnswered && (
             <div className='text-center my-4'>
             <h4 className='fs-5 '>Voice Mail Script</h4>
             <p>This is TPV Solutions calling on behalf of {clientName} to confirm your enrollment for energy service. We will attempt to call you again tomorrow.</p>
           </div>
          )}
          {(leaveMessage || showGoBack || CallNotAnswered) && (
            <div className='text-center'>
              <button
                className='btn btn-danger me-2'
                onClick={() => navigate(`/${getUrlParams.adminUser}/outbound-liveagent`)}
              >
                Go back
              </button>
            </div>
          )}
        </div>
      </KTCard>
    </>
  )
}

export default OutboundLiveAgentCall
